import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { RootState } from "./store/types";
import { auth } from "./store/auth/index";
import { user } from "./store/user/index";
import { owner } from "./store/owner/index";
import { farms } from "./store/farms/index";
import { location } from "./store/location/index";
import { crops } from "./store/crops/index";
import { notification } from "./store/notification/index";
import { vegetationIndex } from "./store/vegetation-index/index";
import { analyses } from "./store/analyses/index";
import { metadata } from "./store/metadata/index";
import { results } from "./store/results/index";
import { monitoring } from './store/monitoring/index';
import { weather }  from './store/weather/index';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    loading: false
  },
  modules: {
    auth,
    user,
    owner,
    farms,
    location,
    crops,
    notification,
    vegetationIndex,
    analyses,
    metadata,
    results,
    monitoring,
    weather,
  }
};

export default new Vuex.Store(store);
